import {IShapeDiverOutputDefinitionChunk} from "@AppBuilderLib/entities/output/config/output";
import TextWeighted from "@AppBuilderLib/shared/ui/text/TextWeighted";
import TooltipWrapper from "@AppBuilderLib/shared/ui/tooltip/TooltipWrapper";
import {Group, MantineThemeComponent, useProps} from "@mantine/core";
import React from "react";
import type {OutputChunkLabelComponentThemeDefaultProps} from "shared/entities/output/config/OutputChunkLabelComponent.types";

interface Props {
	chunk: IShapeDiverOutputDefinitionChunk;
	/** Component to show on the right hand side of the label */
	rightSection?: React.ReactNode;
}

const defaultStyleProps: OutputChunkLabelComponentThemeDefaultProps = {};

type OutputChunkLabelComponentPropsType =
	Partial<OutputChunkLabelComponentThemeDefaultProps>;

export function OutputChunkLabelComponentThemeProps(
	props: OutputChunkLabelComponentPropsType,
): MantineThemeComponent {
	return {
		defaultProps: props,
	};
}

/**
 * Functional component that creates a label for an output chunk.
 *
 * @returns
 */
export default function OutputChunkLabelComponent(
	props: Props & Partial<OutputChunkLabelComponentThemeDefaultProps>,
) {
	const {fontWeight, rightSection, ...rest} = useProps(
		"OutputChunkLabelComponent",
		defaultStyleProps,
		props,
	);
	const {chunk} = rest;
	const {displayname, name, tooltip} = chunk;
	const label = displayname || name;

	const labelcomp = (
		<TextWeighted pb={4} size="sm" fontWeight="medium" fw={fontWeight}>
			{label}
		</TextWeighted>
	);

	return (
		<Group justify="space-between" w="100%" wrap="nowrap">
			{tooltip ? (
				<TooltipWrapper label={tooltip} position="top">
					{labelcomp}
				</TooltipWrapper>
			) : (
				labelcomp
			)}
			{rightSection}
		</Group>
	);
}
